import {RootState} from '../../../store/store';
import {useSelector} from 'react-redux';

function selector(state: RootState) {
    return state.globalParking;
}

export function useGlobalParking() {
  return useSelector<RootState, ReturnType<typeof selector>>(selector);
}
